<template>
  <RouterLink v-if="to" :to="to" :class="cls">
    <slot></slot>
  </RouterLink>
  <a v-else-if="href" :href="href" target="_blank" :class="cls">
    <slot></slot>
  </a>
  <button v-else type="button" :class="cls">
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { normalizeClass } from "vue";

import type { RouteLocation } from "@/router/types";

defineProps<{
  to?: RouteLocation;
  href?: string;
}>();

const cls = normalizeClass([
  "rounded border border-border bg-background px-2 py-1 text-xs font-medium text-foreground transition hover:bg-muted active:bg-muted",
]);
</script>
